/*
saikrishna 11/03/2022 3075154998 changed the paginationOptions
*/
import React, {createRef, useState, useEffect} from 'react';
// import MaterialTable from "material-table";
import {TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {Button} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import {
  AddNotes as addNotes,
  ResetMessage as resetMessage,
  ResetStatus as resetStatus,
} from '../../../../../redux/reducers/EnableFramework/Filter';
import DialogBox from '../../../../../components/DialogBox';
import AddUserDefinedNotes from '../../../../../components/AddUserDefinedNotes';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';

export default function FiltersSystemNotes({
  filterCode,

  filterCodeName,
}) {
  let transcription = '';
  const moment = require('moment-timezone');
  const tableRef = createRef();
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  const {addNoteStatus, isLoading} = useSelector(({filter}) => filter);
  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };
  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };
  useEffect(() => {
    if (addNoteStatus === 200) {
      tableRef.current.onQueryChange();
      handleDialogClose();
      dispatch(resetStatus());
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [addNoteStatus]);
  const dispatchRecordFormatSystemNotes = (data) => {
    if (data) {
      dispatch(
        addNotes({
          code: filterCodeName ? filterCodeName : '',
          noteText: data,
        }),
      );
    }
  };
  const columns = [
    {
      title: 'Note Type',
      field: 'noteType',
    },
    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Filter Code',
      field: 'filterCode',
      render: (rowData) => <>{rowData?.code}</>,
    },
    {
      title: 'Note Text',
      field: 'noteText',
      cellStyle: {
        minWidth: '550px',
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
  ];

  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);

  return (
    <>
      <div className="custom-table global-field-table custom-toolbar-icons">
        <GuiTable
          title=""
          columns={columns}
          icons={tableIcons}
          tableRef={tableRef}
          data={(query) =>
            new Promise((resolve) => {
              const url = `enableintegration/find/all/notes`;
              const bodyObj = {
                code: filterCodeName,
                limit: rows,
                orderBy: '',
                orderDirection: '',
                search: '',
                page:
                  arrayLast && query.page >= 1 ?
                    query.page :
                    arrayLast ?
                      (query.page <= 1 && query.page + 1) || query.page - 1 :
                      query.page + 1,
              };
              if (!filterCode) {
                resolve({
                  data: [],
                  page: 0,
                  totalCount: 5,
                });
              } else {
                httpPaginationPost(url, bodyObj)
                  .then((response) => {
                    if (response?.status === 200) {
                      const data = response.data.response.resultObjects;
                      resolve({
                        data: data.length > 0 ? data : [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                      setArrayLast(response.data.response.resultObjects.length === 1);
                    } else {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    }
                  })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              }
            })
          }
          options={{
            search: false,
            pageSize: rows,
            showSelectAllCheckbox: false,
            emptyRowsWhenPaging: false,
            pageSizeOptions: tablePageRows,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          actions={[
            {
              icon: () => (
                <div>
                  <Button variant="outlined" className="search-btn">
                    <AddIcon /> Add
                  </Button>
                </div>
              ),
              isFreeAction: true,
              onClick: () => handleSelectedNotesOption(),
            },
          ]}
          components={{
            Pagination: (props) => (
              <TablePagination
                {...props}
                rowsPerPageOptions={tablePageRows}
                onChangeRowsPerPage={(event) => {
                  props.onChangeRowsPerPage(event);
                  setRows(event.target.value);
                }}
              />
            ),
          }}
        />
      </div>
      <DialogBox
        title="User Defined Notes"
        button2Text="Save"
        button1Text="Cancel"
        open={isAddaNoteDialogOpen}
        dialogClose={handleDialogClose}
        maxWidth={'md'}
      >
        {isAddaNoteDialogOpen && (
          <AddUserDefinedNotes
            transcription={transcription}
            setWebSocketOnClose={setWebSocketOnClose}
            charLimitMsg={charLimitMsg}
            isLoading={isLoading}
            setCharLimitMsg={setCharLimitMsg}
            dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
          />
        )}
      </DialogBox>
    </>
  );
}
